import { all, takeEvery, put, select } from 'redux-saga/effects'
import { startSubmit, stopSubmit } from 'redux-form/immutable'
import { push } from 'connected-react-router'
import i18next from 'i18next'

import { activeProTrackLevel } from 'store/entities/identity/selectors'
import { modal } from 'store/entities/modal/actions'
import { unsubscribeProgress, subscribeToProTrack } from '../actions'
import ConfirmOrCancel from 'app/domains/common/Modals/ConfirmOrCancel'
import { store } from 'store'
import { WHY_YOU_CHANGE_PROPTRACK_FORM_NAME, SWITCH_PROTRACK_FROM_EMAIL } from 'app/constants/profile'
import { showInfo } from 'store/entities/toastr/utils'
import { isShowConfirmationModalForDifferentProTrack, getQueries } from 'store/entities/localSettings/selectors'
import {
  setConfirmationModalForDifferentProTrack,
  setQueries,
  setConfirmationModal,
} from 'store/entities/localSettings/actions'

export function* handleUnsubscribeProgress({ payload: { formName } }) {
  yield put(startSubmit(formName))
}

export function* handleUnsubscribeProgressSuccess({ meta }) {
  // set requests to clear stopSource so that stoppedFrom write correct values
  yield put(setQueries({ stopSource: null }))
  const proTrack = yield select(activeProTrackLevel)
  const isShowDifferentProTrack = yield select(isShowConfirmationModalForDifferentProTrack)
  const { formName } = meta
  showInfo({
    content: i18next.t(`user:You stopped proTrack`, {
      proTrackName: proTrack.get('proTrackName'),
      name: proTrack.get('name'),
    }),
  })
  yield put(modal.hide())
  yield put(stopSubmit(formName))
  yield put(modal.hide())
  if (formName === WHY_YOU_CHANGE_PROPTRACK_FORM_NAME) {
    yield put(push('/select-protrack'))
  } else if (isShowDifferentProTrack) {
    yield put(push('/select-protrack'))
    yield put(setConfirmationModalForDifferentProTrack(false))
  } else if (formName === SWITCH_PROTRACK_FROM_EMAIL) {
    const queries = yield select(getQueries)
    const proTrackLevelId = queries.get('proTrackLevelId')
    yield put(subscribeToProTrack({ proTrackLevelId, isSubscriptionFromEmail: true }))
    yield put(setConfirmationModal(false))
  }
}

export function* handleUnsubscribeProgressFail({ payload, meta }) {
  yield put(stopSubmit(meta.formName))
  if (payload.error && payload.message) {
    yield put(modal.hide())
    showInfo({ content: payload.message })
    yield put(
      modal.show(ConfirmOrCancel, {
        size: 'sm',
        title: 'You have no active ProTracks now',
        confirmBtn: 'Go To Select',
        handleSubmit: () => {
          modal.hide()
          store.dispatch(push('/select-protrack'))
        },
      })
    )
  }
}

export default function* unsubscribeProgressSaga() {
  yield all([
    takeEvery(unsubscribeProgress.toString(), handleUnsubscribeProgress),
    takeEvery(unsubscribeProgress.success.toString(), handleUnsubscribeProgressSuccess),
    takeEvery(unsubscribeProgress.fail.toString(), handleUnsubscribeProgressFail),
  ])
}
